<template>
    <div class="agent-page">
        <div style="display: flex; flex-direction: column; text-align: start;">
            <h2 class="page-title" style="font-size: 15px;">{{ projectTitle }}</h2>
            <div style="display: flex; align-items: center; justify-content: space-between;">
                <h2 class="page-title" style="margin-top: 10px;">下载招标文件</h2>
                <el-button type="primary" icon="el-icon-arrow-left" size="small"
                    @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 表格内容 -->
        <div class="content-wrap">
            <el-table :data="tableData" border style="width: 100%" class="tender-table" v-loading="loading">
                <el-table-column prop="no" label="NO." width="80" align="center"></el-table-column>
                <el-table-column prop="bidInvitationDocumentsCode" label="招标文件编号" min-width="200"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="bidInvitationDocumentsName" label="招标文件名称" min-width="200"
                    show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleDownload(scope.row)" class="download-btn">下载文件</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 下载弹窗 -->
        <el-dialog title="选择下载类型" :visible.sync="downloadDialogVisible" width="400px" center>
            <div class="download-dialog-content">
                <el-button type="primary" class="download-type-btn" @click="downloadPdf">下载 PDF</el-button>
                <el-button type="primary" class="download-type-btn" @click="downloadDoc">下载 文档</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getBidderFlowTitle } from '@/utils/bid/projectInfo'
import { Api_GetSemiDocList, Api_GetSemiDocDownloadUrl } from '@/api/modules/semiProcess'
export default {
    name: 'DownloadTender',
    data() {
        return {
            sectionCode: this.$route.query.sectionCode || '',
            projectTitle: '',
            tableData: [],
            loading: false,
            currentPage: 1,
            pageSize: 10,
            total: 0
        }
    },
    mounted() {
        this.getProjectInfo()
        this.loadData()
    },
    methods: {
        // 获取项目信息
        async getProjectInfo() {
            this.projectTitle = await getBidderFlowTitle(this.sectionCode)
        },
        // 加载数据
        loadData() {
            this.loading = true
            Api_GetSemiDocList(this.sectionCode).then(res => {
                this.loading = false
                if (res.code === 200) {
                    const list = res.data || []
                    this.tableData = list.map((item, index) => ({
                        ...item,
                        no: (this.currentPage - 1) * this.pageSize + index + 1
                    }))
                    this.total = list.length
                } else {
                    this.$message.error(res.msg || '获取招标文件列表失败')
                }
            }).catch(() => {
                this.loading = false
                this.$message.error('获取招标文件列表失败')
            })
        },
        // 获取标段列表
        async getSectionList(projectCode) {
            const res = await Api_GetSectionList({
                projectCode: projectCode
            })
            if (res.code === 200) {
                this.tableData = res.data
            }else{
                this.$message.error(res.msg)
            }
        },





        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 下载文件弹窗
        handleDownload(row) {
            Api_GetSemiDocDownloadUrl(row.bidInvitationDocumentsCode).then(res => {
                if (res.code === 200 && res.data) {
                    window.open(res.data, '_blank')
                } else {
                    this.$message.error(res.msg || '获取下载地址失败')
                }
            }).catch(() => {
                this.$message.error('获取下载地址失败')
            })
        },
        // 下载 PDF
        async downloadPdf() {
            if (!this.currentDownloadRow) return
            try {
                const res = await getInvitationMain(this.currentDownloadRow.bidSectionCode)
                if (res.code === 200 && res.data) {
                    
                    window.open(res.data, '_blank')
                } else {
                    this.$message.error(res.msg || 'PDF文件不存在')
                }
            } catch (error) {
                this.$message.error('下载失败')
            }
            this.downloadDialogVisible = false
        },
        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val
            this.loadData()
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/agent-common.css';

.page-title {
    color: #333;
    margin: 0;
    font-weight: bold;
}

.content-wrap {
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    background: white;
}

.tender-table {
    .el-table__header {
        background-color: #f5f7fa;
    }

    .el-table__header th {
        background-color: #f5f7fa;
        color: #333;
        font-weight: 600;
    }

    .download-btn {
        color: #409EFF;
        font-weight: 500;

        &:hover {
            color: #66b1ff;
        }
    }
}

.pagination-container {
    margin-top: 20px;
    text-align: right;
}

.download-dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 20px 0;

    .download-type-btn {
        width: 200px;
        height: 44px;
        font-size: 16px;
    }
}
</style>